import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setMerchantSettings } from '../store/reducers/general';
import { callGetWebservice } from './api';

const useMerchantSettings = () => {
    const dispatch = useDispatch();
    const merchantSettings = useSelector((state) => state.general.merchantSettings);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!merchantSettings || Object.keys(merchantSettings).length === 0) {
            setLoading(true);
            setError(null);

            const requestPacket = {};
            callGetWebservice('merchant', requestPacket, (response) => {
                dispatch(setMerchantSettings(response.data));
                setLoading(false);
            }, (err) => {
                setError(err.errMessage);
                setLoading(false);
            });
        }
    }, [merchantSettings, dispatch]);

    return { merchantSettings, loading, error };
};

export default useMerchantSettings;
